import styled from "styled-components";
export const StyledButton = styled.a`
text-decoration: none;
padding: 1rem 2.5rem;
border-radius: 50px;
font-size: 1rem;

`
